import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';
export const styles = createTypedSxStyles({
  reportSettings: {
    background: capitalDesignTokens.foundations.colors.gray100,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
    padding: '16px',
    paddingLeft: '24px',
    paddingRight: '24px'
  },
  cardContainer: {
    margin: '16px 0'
  },
  container: {
    padding: '16px'
  },
  containerBody: {
    padding: '0px',
    '&:last-child': {
      padding: '0px'
    }
  },
  containerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px'
  },

  contentContainer: {
    display: 'flex',
    paddingTop: '8px'
  },
  divider: {
    margin: '16px -16px 16px -16px',
    width: '100%'
  },

  flexHorizontal: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    '& > :first-of-type': {
      paddingRight: '16px'
    }
  },

  expand: {
    '&:first-of-type': {
      flex: 3
    },
    '&:last-child': {
      flex: 1
    }
  },

  aboutContentBlockHeader: {
    button: {
      marginLeft: '10px'
    },
    '& .MuiButtonBase-root': {
      width: '80px'
    }
  },
  fauxHeader: {
    color: capitalDesignTokens.foundations.colors.gray700,
    paddingBottom: 0
  },
  deleteDescription: {
    paddingBottom: '0px'
  },
  mdsReportMainContainer: {
    paddingRight: '24px'
  },
  mdsReportDetailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '16px',
    '& .MuiTypography-root': {
      padding: 0
    }
  },
  mdsReportDetailsDescContainer: {
    display: 'flex',
    flexDirection: 'row',
    '& .MuiTypography-root': {
      padding: 0
    }
  },
  detailsTitle: {
    width: '180px',
    marginRight: '16px',
    color: capitalDesignTokens.foundations.colors.gray700
  },

  mdsReportDataContainer: {
    p: {
      marginBottom: '12px'
    }
  },

  mdsReportDataText: {
    marginBottom: '8px',
    color: capitalDesignTokens.foundations.colors.gray700
  },

  mdsReportDataLink: {
    marginBottom: '8px'
  },

  deleteContentBlock: {
    marginTop: '16px'
  },

  deleteContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },

  deleteWarning: {
    justifyContent: 'flex-start',
    flex: 3
  },

  visibilityContentBlock: {
    '& .MuiTypography-root': {
      paddingBottom: '0px'
    }
  },
  visibilityContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  copyButton: {
    right: '0px',
    maxWidth: '100px'
  },
  copyLinkContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '8px',
    marginBottom: '8px',
    '& .MuiFormHelperText-root': { paddingBottom: '0px' }
  },

  tableContainer: { height: 300, width: '100%' },
  loader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1.5
  },
  granteeName: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  groupIcon: {
    marginLeft: '8px',
    fontSize: '16px'
  },
  copyLinkSuccess: { display: 'flex', alignItems: 'center', gap: '8px' },
  visibilityInput: {
    display: 'flex',
    fieldset: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    '&:hover fieldset': {
      borderTopRightRadius: '0' + '!important',
      borderBottomRightRadius: '0' + '!important'
    }
  }
});
